import type { Environment } from '@prisma/client';

export const ENVIRONMENT_NAMES: Record<Environment, string> = {
  ALL: 'All Environments',
  PRODUCTION: 'Production',
  STAGING: 'Staging',
  DEVELOPMENT: 'Development',
  NONE: 'None',
} as const;
